// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yGFD","colMin":"styles_colMin__1uTRg"};